export default function getFrontendHost(isSocket, isHost) {

  const deployEnv = process.env.ACARA_DEPLOY_ENV;

  const protocol = isSocket ? 'ws://' : 'http://';
  const protocolSsl = isSocket ? 'wss://' : 'https://';


  if (deployEnv === 'test') {
    return protocolSsl+'staging.acara.io/';
  } else if (deployEnv === 'staging') {
    return protocolSsl+'staging.acara.io/';
  } else if (deployEnv === 'production') {
    return protocolSsl+'app.acara.io/';
  }

  const isLocalHost = typeof window !== 'undefined' && window && window.location && window.location.hostname && window.location.hostname === 'localhost';
  const regexIp = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/gi;
  const isIp = typeof window !== 'undefined' && window ? regexIp.test(window.location.hostname) : '';

  const getIpHostIp = typeof window !== 'undefined' && window && window.location && window.location.hostname && window.location.hostname !== 'localhost' && !isIp || isLocalHost && !isIp ? 'localhost' : typeof window !== 'undefined' && window ? window.location.hostname : 'localhost';
  const port = typeof window !== 'undefined' && window && window.location && window.location.port ? window.location.port : '8080';

  return isHost ? getIpHostIp : `${protocol+getIpHostIp +':'+ port}/`;

}
